import { BaseProcessor, ColumnMetaData } from './BaseProcessor';

export class EcdfChart extends BaseProcessor {
  protected override chartType: string = 'line';
  constructor(
    data: { [key: string]: any }[],
    yAxis: string[],
    groupBy: string[],
    columnsMetaData: { [key: string]: ColumnMetaData } = {},
    options: any = {}
  ) {
    super();
    this.data = data;
    this.yAxis = yAxis;
    this.groupBy = groupBy;
    this.columnsMetaData = columnsMetaData;
    this.options = options;
    this.addChartTypeToOptions();
  }

  protected addToolTip() {
    this.options.tooltip = {
      headerFormat: '<span style="font-size: 10px">{point.key}</span><br/>',
      pointFormatter: function () {
        // Format point.y with commas as thousands separator
        const formattedY =
          typeof this.y === 'number'
            ? this.y.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : this.y;
        return `<span style="color:${this.color}">\u25CF</span> ${this.series.name}: <b>${formattedY}</b><br/>`;
      },
    };
  }

  protected addPlotOptions() {
    this.options.plotOptions = this.options?.plotOptions || {};
    this.options.plotOptions.series = {
      marker: {
        enabled: false,
      },
    };
  }
  protected override preprocessData() {
    delete this.options.series;
    this.options.xAxis = {};
    this.options.series = this.yAxis.map((col: any) => {
      return {
        name: col,
        data: this.data.map((values: any) => {
          return this.formateValueWithType(
            values[col],
            this.columnsMetaData[col]
          );
        }),
      };
    });

    this.addYAxisTitle();
    this.addToolTip();
    this.addPlotOptions();
  }
}
